import { render, staticRenderFns } from "./TransactionData.vue?vue&type=template&id=f76d4dfe&scoped=true"
import script from "./TransactionData.vue?vue&type=script&lang=js"
export * from "./TransactionData.vue?vue&type=script&lang=js"
import style0 from "./TransactionData.vue?vue&type=style&index=0&id=f76d4dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76d4dfe",
  null
  
)

export default component.exports